export const formatDate = (date: string | Date | null) => {
  if (!date) return "Not specified";
  const d = typeof date === "string" ? new Date(date) : date;
  if (isNaN(d.getTime())) return "Not specified";
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// DD/MM/YYYY format

export const formatToDDMMYYYY = (
  dateInput: string | Date | null | undefined,
) => {
  if (!dateInput) return "Invalid Date";

  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date.getTime())) return "Invalid Date";

  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export const formatDateTime = (dateString: string | Date) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
